import { useEffect, useState } from 'react'

type TabItem = { key: string }

export const useSafelySelectedTab = (
  tabItems: TabItem[],
  initialKey?: (typeof tabItems)[number]['key'],
) => {
  const [selectedKey, setSelectedKey] = useState(initialKey ?? tabItems[0].key)
  const selectedIndex = tabItems.findIndex((item) => item.key === selectedKey)

  useEffect(() => {
    if (selectedIndex === -1 || selectedIndex >= tabItems.length) {
      setSelectedKey(tabItems[0].key)
    }
  }, [selectedIndex, tabItems])

  const onTabChange = (nextIndex: number) => {
    setSelectedKey(tabItems[nextIndex].key)
  }

  return { selectedIndex, onTabChange }
}
